import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import './EnterpriseSuggestedActionsPlaceholder.styles.scss';

type EnterpriseSuggestedActionsPlaceholderProps = IContentLoaderProps & {
  count?: number;
};

const SuggestedActionItemPlaceholder: React.FC<IContentLoaderProps> = (
  props,
) => {
  return (
    <ContentLoader
      {...props}
      viewBox="0 0 840 72"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
    >
      <circle cx="24" cy="36" r="20" />
      <rect x="60" y="20" rx="7" ry="7" width="240" height="16" />
      <rect x="60" y="44" rx="6" ry="6" width="360" height="12" />
      <rect x="716" y="22" rx="6" ry="6" width="104" height="28" />
    </ContentLoader>
  );
};

const EnterpriseSuggestedActionsPlaceholder: React.FC<
  EnterpriseSuggestedActionsPlaceholderProps
> = (props) => {
  const { count = 10, ...rest } = props;

  return (
    <div className="enterprise-suggested-actions-placeholder">
      {Array.from({ length: count }).map((_, index) => (
        <SuggestedActionItemPlaceholder key={index} {...rest} />
      ))}
    </div>
  );
};

export default EnterpriseSuggestedActionsPlaceholder;
